import React, { useState } from "react";
import HStack from "@components/layout/HStack";
import { useThemeStore } from "@shared/stores";
import { ChevronDown } from "../icons/IconCustom";

type Props = {
  header: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  iconLeft?: boolean;
};

const AccordionTree = ({ header, children, defaultOpen = false, className = "", iconLeft = false }: Props) => {
  const { isDarkMode } = useThemeStore();
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`w-full ${className}`}>
      {/* Header */}
      <div className="w-full select-none text-darkGray dark:text-white">
        <HStack justifyContent="between" className="w-full">
          {iconLeft ? (
            <HStack className="w-full">
              <button type="button" onClick={() => setIsOpen((o) => !o)} className="focus:outline-none">
                <ChevronDown
                  isDarkMode={isDarkMode}
                  size={16}
                  className={`transition-transform duration-200 ${isOpen ? "rotate-0" : "-rotate-90"}`}
                />
              </button>
              {header}
            </HStack>
          ) : (
            <>
              {header}
              <button type="button" onClick={() => setIsOpen((o) => !o)} className="p-1 focus:outline-none">
                  <ChevronDown
                  isDarkMode={isDarkMode}
                  size={16}
                  className={`transition-transform duration-200 ${isOpen ? "rotate-0" : "-rotate-90"}`}
                />
              </button>
            </>
          )}
        </HStack>
      </div>

      {/* Content */}
      {isOpen ? (
        <div className="w-full">
          <div className="text-sm text-darkGray dark:text-white">{children}</div>
        </div>
      ) : null}
    </div>
  );
};

export default AccordionTree;
